export default __webpack_public_path__ + "static/Content-marketing-74c027aa174591c8efb0724ee7609872.webp";